export default __webpack_public_path__ + "static/media/clipboard.37491caa.svg";